import React from 'react';

import './NumberWidgetBar.scss';
import NumberFormatter from '../../lib/numberFormatter';
import customNumber from '../../lib/customNumberFormatter';

class NumberWidgetBar extends React.Component {
    render() {
        let className = 'widgetContainer';

        const { widget, widgetData, isThumbnail } = this.props;

        let value = 0;
        let budget = 0;
        let totalBudget = 0;
        let totalValue = 0;

        if (widgetData) {
            if (widgetData.length > 0) {
                for (let i = 0; i < widgetData.length; i += 1) {
                    totalValue += widgetData[i].value;
                    totalBudget += widgetData[i].budget;
                }

                value = Math.floor(totalValue);
                budget = Math.floor(totalBudget);
            } else if (widgetData.length === 0) {
                if (widgetData[0] && widgetData[0]) {
                    value = widgetData[0].value;
                    budget = widgetData[0].budget;
                }
            } else {
                console.log('this is strange, nothing loaded from cache.');
            }
        }

        if (widget.displayConfig && widget.displayConfig.budget) {
            if (widget.displayConfig.budget != null || 0 || '') {
                budget = parseInt(widget.displayConfig.budget, 10);
                totalBudget = budget;
            }
        }

        let _value;
        let _budget;
        switch (widget.dataType) {
        case 'open/clicked':
            _value = `${_.round((totalValue / totalBudget) * 100, 2) || 0}%`;
            _budget = `${NumberFormatter.shortenLargeNumber(value, 2)} öppnade`;
            break;
        default:
            _value = NumberFormatter.shortenLargeNumber(value, 2);
            _budget = `Budget: ${NumberFormatter.shortenLargeNumber(budget, 2)}`;
        }    

        let percent = (totalValue / totalBudget) * 100;

        if (percent >= 100) {
            className += ' budget_achieved_numberwidget';

            percent = 100;
        }

        return (
            <div className={className}>
                {!isThumbnail && <div className="number_bar_widget">
                    <svg viewBox="0 0 80 30">
                        <text x="40" y="20">
                            <tspan x="40" dy="-10">{_value}</tspan>
                            <tspan x="40" dy="13" className="budget">{_budget}</tspan>
                        </text>
                    </svg>
                    <svg viewBox="0 0 100 20">
                        <rect x="0" dy="25" className="progress_bar_container" />
                        <rect x="0" dy="25" className="progress_bar" style={{ width: `${percent}%` }} />
                    </svg>
                </div>}
            </div>
        );
    }
}

NumberWidgetBar.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
};

export default NumberWidgetBar;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/NumberWidgetBar.jsx
 **/